<div class="tracks-container p-2" (contextmenu)="$event.preventDefault()">
    <div class="tracks-toolbar mb-5 mt-3 flex">
        <h1 class="tracks-title">Tracks</h1>

        <div class="folder-action">
            <button
                type="button"
                class="add-folder-button"
                aria-label="Create folder"
                (click)="createFolder()">
                <span class="add-folder-icon" aria-hidden="true">+</span>
                <span class="add-folder-label">Folder</span>
            </button>
        </div>
    </div>

    <app-table
        [columnsConfig]="tracksColumnsConfig"
        [mobileColumnsConfig]="mobileColumnsConfig"
        [animatedFolderID]="animatedFolderID"></app-table>
</div>
